// PATH: src/pages/AdminLogin.jsx
// VERSION: 1.3 — redirige a /admin/dashboard tras login o si ya está autenticado

import React, { useEffect, useState } from 'react';
import { Box, Heading, Input, Button, VStack, useToast, Alert, AlertIcon, InputGroup, InputRightElement, IconButton } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useAdminAuth } from '../context/AdminAuthContext';
import ENV from '../config/adminEnv';

export default function AdminLogin() {
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  const { login, isAdmin } = useAdminAuth();
  const [pwd, setPwd] = useState('');
  const [showPwd, setShowPwd] = useState(false);

  // Permite ?next=/ruta/protegida en la URL; por defecto /admin/dashboard
  const params = new URLSearchParams(location.search);
  const redirectTo = params.get('next') || '/admin/dashboard';

  // Si ya estás autenticado, redirige enseguida
  useEffect(() => {
    if (isAdmin) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAdmin, redirectTo, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const { ok, message } = await login(pwd);
    toast({ title: message, status: ok ? 'success' : 'error' });
    if (ok) {
      navigate(redirectTo, { replace: true });
    }
  };

  return (
    <Box maxW="sm" mx="auto" mt={10}>
      <Heading size="md" mb={4}>Acceso de administrador</Heading>

      {ENV.ADMIN_BYPASS && (
        <Alert status="info" mb={4}>
          <AlertIcon />
          El acceso está habilitado con <b>BY-PASS</b> (no se requiere contraseña por ahora).
        </Alert>
      )}

      <form onSubmit={onSubmit}>
        <VStack spacing={3} align="stretch">
          <InputGroup>
            <Input
              type={showPwd ? 'text' : 'password'}
              placeholder="Contraseña"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              isDisabled={ENV.ADMIN_BYPASS}
            />
            <InputRightElement>
              <IconButton
                size="sm"
                variant="ghost"
                onClick={() => setShowPwd(!showPwd)}
                icon={showPwd ? <FiEyeOff /> : <FiEye />}
                aria-label={showPwd ? 'Ocultar contraseña' : 'Ver contraseña'}
              />
            </InputRightElement>
          </InputGroup>
          <Button type="submit" colorScheme="blue" isDisabled={ENV.ADMIN_BYPASS}>
            Entrar
          </Button>
          {isAdmin && <Box color="green.500">Ya estás autenticado. Redirigiendo…</Box>}
        </VStack>
      </form>
    </Box>
  );
}
